import { MqttStorage } from "./mqtt-storage";

/**
 * A reference implementation of MqttStorage
 *
 * @export
 * @class MqttMemoryStorage
 * @implements {MqttStorage}
 */
export class MqttMemoryStorage implements MqttStorage {
    private data: Record<string, string> = {};

    clear() {
        this.data = {};
    }

    set(key: string, packet: string): void {
        this.data[key] = packet;
    }

    get(key: string): string {
        return this.data[key];
    }

    getAll(): string[] {
        return Object.values(this.data);
    }

    remove(key: string): void {
        delete this.data[key];
    }
}
